import { useTranslation } from 'react-i18next'
import { Megaphone, Radar, ScanSearch } from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useScrollReveal } from './useScrollReveal'

const useCases: { key: string; icon: LucideIcon }[] = [
  { key: 'politicalResearch', icon: Radar },
  { key: 'mediaMonitoring', icon: ScanSearch },
  { key: 'reputationMonitoring', icon: Megaphone },
]

export function UseCasesSection() {
  const { t } = useTranslation()
  const { ref, isVisible } = useScrollReveal()

  return (
    <section
      id="use-cases"
      className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 lg:px-8 lg:py-24"
    >
      <div ref={ref} className={cn('scroll-reveal', isVisible && 'is-visible')}>
        <div className="mb-10 max-w-2xl">
          <h2 className="m-0 text-2xl font-semibold tracking-tight text-foreground sm:text-3xl">
            {t('landing.useCases.title')}
          </h2>
          <p className="mt-3 text-base leading-relaxed text-muted-foreground">
            {t('landing.useCases.subtitle')}
          </p>
        </div>

        <div className="grid gap-4 md:grid-cols-3">
          {useCases.map((item) => {
            const Icon = item.icon
            return (
              <article
                key={item.key}
                className="rounded-xl bg-glass p-5 ring-1 ring-glass-ring backdrop-blur-md transition-colors duration-200 hover:bg-glass-hover"
              >
                <div className="inline-flex h-10 w-10 items-center justify-center rounded-xl bg-icon-frame text-icon-frame-foreground ring-1 ring-icon-frame-ring">
                  <Icon size={18} />
                </div>
                <h3 className="mb-0 mt-4 text-base font-medium text-foreground">
                  {t(`landing.useCases.items.${item.key}.title`)}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-muted-foreground">
                  {t(`landing.useCases.items.${item.key}.description`)}
                </p>
              </article>
            )
          })}
        </div>
      </div>
    </section>
  )
}
